<template>
  <v-layout row>
    <v-flex 
      sm12 
      md8 
      offset-md2
      xl6
      offset-xl3>
      <v-alert 
        v-if="checkAlerts"
        :color="currentStep.type === userType ? 'success' : 'info'" 
        :value="true">
        <v-icon 
          left 
          dark>
          {{ currentStep.type === userType ? 'edit' : 'info' }}
        </v-icon>
        {{ checkAlerts }}
      </v-alert>     
      <v-card v-if="placement.startDate">
        <v-toolbar 
          color="primary" 
          dark>
          <v-toolbar-title><strong v-html="placement.unit + ':'"/> {{ placement.unitName }}</v-toolbar-title>
          <v-spacer/>
          <v-tooltip 
            bottom 
            v-if="placement.pdfURL">
            <v-btn 
              :href="placement.pdfURL"
              slot="activator" 
              flat 
              icon>
              <v-icon dark>print</v-icon>
            </v-btn>
            <span>Print</span>
          </v-tooltip>
          <StaffPlacementForm 
            v-if="!placement.locked && userType === 'Staff'" 
            :edititem="placement"/>
          <StudentPlacementForm 
            v-if="!placement.locked && userType === 'Student'"  
            :edititem="placement"/>
          <v-spacer/>
          <span class="caption hidden-xs-only">Last update: {{ placement.lastUpdate.seconds | moment("calendar") }}</span>
        </v-toolbar>        
        <v-card-actions>
          <v-spacer/>
          <v-chip v-if="checkDates()">
            First day of placement commenced
            {{ placement.startDate | moment("from") }}
          </v-chip>
          <v-chip v-else>
            First day of placement commencing
            {{ placement.startDate | moment("from") }}
          </v-chip>
          <v-spacer/>
        </v-card-actions>
        <v-card-title primary-title>
          <div class="title">Placement details:</div>
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class="text-xs-left">Student:</th><td><span class="grey--text text--darken-1">{{ placement.displayName }} {{ placement.studentId }}</span></td>
            </tr>
            <tr>
              <th class="text-xs-left">Course:</th><td><span class="grey--text text--darken-1">{{ placement.course }} ({{ placement.courseName }})</span></td>
            </tr>
            <tr>
              <th class="text-xs-left">Unit:</th><td><span class="grey--text text--darken-1">{{ placement.unit }} ({{ placement.unitName }})</span></td>
            </tr>
            <tr>
              <th class="text-xs-left">Campus:</th><td><span class="grey--text text--darken-1">{{ placement.campus }}</span></td>
            </tr>
            <tr>
              <th class="text-xs-left">Organisation:</th><td><span class="grey--text text--darken-1">{{ placement.organisationName }} ({{ placement.organisation }})</span></td>
            </tr>            
            <tr>
              <th class="text-xs-left">Dates:</th>
              <td>
                <span class="grey--text text--darken-1">
                  {{ placement.startDate | moment("dddd, MMMM Do YYYY") }} - {{ placement.endDate | moment("dddd, MMMM Do YYYY") }}
                </span>
              </td>
            </tr>
          </table>
          <div v-if="placement.instructions">
            <v-btn 
              flat 
              color="primary"
              @click="expand = !expand">
              Instructions
              <v-icon 
                right>{{ expand ? 'expand_less' : 'expand_more' }}
              </v-icon>
            </v-btn>
            <v-expand-transition>
              <div 
                v-show="expand" 
                v-html="placement.instructions"/>
            </v-expand-transition>
          </div>

        </v-card-text>
      </v-card>
      <placementSteps
        v-for="(step, index) in steps"
        :key="step['.key']"
        :step="step"
        :active-step="placement.step"
        :next-step="index < (steps.length - 1) ? steps[index + 1] : null"
        :student-uid="placement.uid"
        :placement-key="placement['.key']"
        :locked="!!placement.locked"
        :user-type="userType"
      />
    </v-flex>

  </v-layout>
</template>

<script>
export default {
  name: "Placement",
  props: {
    userType: {
      type: String,
      default: null
    }
  },
  data: () => ({
    hidden: false,
    dialog: false,
    expand: false,
    valid: true,
    placement: null,
    steps: null,
    textRules: [
      v => !!v || "Required",
      v => (v && v.length < 5000) || "Text must be less than 5000 characters"
    ]
  }),
  firestore() {
    return {
      placement:
        this.userType === "Student"
          ? this.$store.getters.db.doc(
              `students/${this.user.uid}/placements/${this.$route.query.key}`
            )
          : this.$store.getters.db.doc(
              `students/${this.$route.params.uid}/placements/${
                this.$route.query.key
              }`
            )
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    currentStep() {
      if (this.steps) {
        return this.steps.find(step => {
          return step.itemOrder === this.placement.step;
        });
      }
    },
    checkAlerts() {
      let alert =
        this.userType === "Academic" ? "alertStaff" : "alert" + this.userType;
      return this.currentStep && this.currentStep[alert]
        ? this.currentStep[alert]
        : false;
    }
  },
  watch: {
    placement: function(val) {
      if (val[".key"]) {
        let self = this;
        this.$store.dispatch("setLoading", false);
        this.$binding(
          "steps",
          this.userType === "Student"
            ? this.$store.getters.db
                .collection(
                  `students/${this.user.uid}/placements/${
                    this.$route.query.key
                  }/steps`
                )
                .orderBy("itemOrder")
            : this.$store.getters.db
                .collection(
                  `students/${this.$route.params.uid}/placements/${
                    this.$route.query.key
                  }/steps`
                )
                .orderBy("itemOrder")
        ).then(steps => {
          self.$store.dispatch("setLoading", false);
        });
      }
    }
  },
  methods: {
    checkDates() {
      let now = this.$moment();
      let startDate = this.$moment(this.placement.startDate);
      if (now > startDate) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>
